export enum AdvertisingPaymentMethodEnum {
  BANK_TRANSFER = "BANK_TRANSFER",
  PAYMEE = "PAYMEE",
  KONNECT = "KONNECT",
  NONE = "NONE",
}
